// Controlled-vocabulary multi-select. Backs the positive/negative note
// pickers on the rating form.

export interface TagPickerProps {
  label: string;
  options: readonly string[];
  value: string[];
  onChange: (next: string[]) => void;
}

export function TagPicker({ label, options, value, onChange }: TagPickerProps) {
  const toggle = (tag: string) => {
    if (value.includes(tag)) {
      onChange(value.filter((t) => t !== tag));
    } else {
      onChange([...value, tag]);
    }
  };
  return (
    <fieldset style={{ border: "1px solid var(--border)", borderRadius: 6, padding: 10 }}>
      <legend style={{ padding: "0 6px", color: "var(--fg-muted)", fontSize: 12 }}>
        {label}
      </legend>
      <div className="row">
        {options.map((opt) => {
          const on = value.includes(opt);
          return (
            <button
              key={opt}
              type="button"
              onClick={() => toggle(opt)}
              className={on ? undefined : "secondary"}
              aria-pressed={on}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
